export default "__VITE_ASSET__5KAJXJwt__"